export function formatPrice(price) {
    if (!price)
        return;
    let formattedPrice = price === null || price === void 0 ? void 0 : price.toString().replace(/\.00$/, '');
    return formattedPrice === null || formattedPrice === void 0 ? void 0 : formattedPrice.replace(/(\.\d)0$/, '$1');
}
